// client/src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const token = localStorage.getItem('crm_token');
    const userRole = localStorage.getItem('user_role');

    // Gate 1: Check basic authentication
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    // Gate 2: Check explicit role-based access permissions
    if (allowedRoles && !allowedRoles.includes(userRole)) {
        alert("⛔ Security Access Denied: You do not have permissions to view this matrix.");
        return <Navigate to="/leads" replace />;
    }

    return children;
};

export default ProtectedRoute;